<template>
    <v-row>
      <div class="col-md-12 home-box">
        <Breadcrumbs :title="'Invoices'"></Breadcrumbs>
        <InvoiceGrid></InvoiceGrid>
      </div>
      <div class="col-md-12 home-tabs-body">
      </div>
    </v-row>
  </template>
  
  <script>
  
  import InvoiceGrid from "@/components/invoices/InvoiceGrid";
  import { createNamespacedHelpers } from "vuex";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Invoices",
    components: {
      InvoiceGrid,
      Breadcrumbs
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  };
  </script>